import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=1a1182b0&"
import script from "./ViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports